import { Injectable } from '@angular/core';

import { ReplaySubject } from 'rxjs';

import { Theme } from '../enums/theme.enum';

/**
 * Service handling application theme.
 */
@Injectable()
export class ThemeService {
	private themeSubject = new ReplaySubject<Theme>(1);

	public theme$ = this.themeSubject.asObservable();

	/**
	 * Get current theme from localstorage, if set. Otherwise, default to light mode.
	 * @returns
	 */
	public getTheme() {
		const theme = localStorage.getItem('theme');

		if (theme) {
			const enumTheme = Theme[theme as keyof typeof Theme];

			if (enumTheme) {
				this.setTheme(enumTheme);
				return;
			}
		}
		this.setTheme(Theme.Light);
	}

	/**
	 * Set theme to input theme.
	 * Sets to html document for css use, to subject for in-code use, and to local storage for future reference.
	 * @param theme Theme to set.
	 */
	public setTheme(theme: Theme) {
		const element = document.querySelector('html');
		if (element) {
			if (theme === Theme.Dark) {
				element.classList.add('theme-dark');
			} else {
				element.classList.remove('theme-dark');
			}
		}
		this.themeSubject.next(theme);
		localStorage.setItem('theme', theme.toString());
	}

	/**
	 * Toggles between themes.
	 */
	public toggleTheme() {
		const currentTheme = Theme[localStorage.getItem('theme') as keyof typeof Theme ?? 'Light'];
		if (currentTheme === Theme.Light) {
			this.setTheme(Theme.Dark);
		} else {
			this.setTheme(Theme.Light);
		}
	}
}
